const starter = {
  en: {
    'starter.fillTitle': "Let's fill your calendar",
    'starter.fillBody':
      'Pick a starter plan and every task is laid out for you. You can change anything later.',
    'starter.tomatoesFromSeed': 'Tomatoes from seed',
    'starter.planSummary': '{weeks} weeks · {count} tasks · starts today',
    'starter.today': 'Today',
    'starter.week': 'Week {week}',
    'starter.weekly': 'Weekly',
    'starter.every2Weeks': 'Every 2 weeks',
    'starter.every3Days': 'Every 3 days',
    'starter.sowIndoors': 'Sow indoors',
    'starter.potOn': 'Pot on seedlings',
    'starter.hardenOff': 'Harden off',
    'starter.transplant': 'Transplant outdoors',
    'starter.pinch': 'Pinch side shoots',
    'starter.feed': 'Feed',
    'starter.water': 'Water',
    'starter.plantCategory': 'Tomatoes',
    'starter.addPlan': 'Add this plan',
    'starter.adding': 'Adding…',
    'starter.emptyCalendar': 'Start with an empty calendar',
    'starter.addFailed': "Couldn't add the starter plan. Please try again.",
  },
  lt: {
    'starter.fillTitle': 'Užpildykime kalendorių',
    'starter.fillBody':
      'Pasirinkite pradinį planą ir visos užduotys bus sudėliotos. Vėliau galėsite viską keisti.',
    'starter.tomatoesFromSeed': 'Pomidorai iš sėklų',
    'starter.planSummary': '{weeks} savaičių · {count} užduočių · prasideda šiandien',
    'starter.today': 'Šiandien',
    'starter.week': 'Savaitė {week}',
    'starter.weekly': 'Kas savaitę',
    'starter.every2Weeks': 'Kas 2 savaites',
    'starter.every3Days': 'Kas 3 dienas',
    'starter.sowIndoors': 'Sėti viduje',
    'starter.potOn': 'Pikuoti daigus',
    'starter.hardenOff': 'Grūdinti',
    'starter.transplant': 'Sodinti lauke',
    'starter.pinch': 'Šalinti pažastinius ūglius',
    'starter.feed': 'Tręšti',
    'starter.water': 'Laistyti',
    'starter.plantCategory': 'Pomidorai',
    'starter.addPlan': 'Pridėti šį planą',
    'starter.adding': 'Pridedama…',
    'starter.emptyCalendar': 'Pradėti tuščiu kalendoriumi',
    'starter.addFailed': 'Nepavyko pridėti pradinio plano. Bandykite dar kartą.',
  },
};

export default starter;
